var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'core', 'collection/base', 'model/categorizer-rule', 'common/location'], function($, core, BaseCollection, CategorizerRuleModel, location) {
  var CategorizerRuleCollection;
  return CategorizerRuleCollection = (function(_super) {

    __extends(CategorizerRuleCollection, _super);

    function CategorizerRuleCollection() {
      CategorizerRuleCollection.__super__.constructor.apply(this, arguments);
    }

    CategorizerRuleCollection.prototype.path = function() {
      return location.categorizerApiPath + 'clientrules/client/' + core.getCurrentClientId();
    };

    CategorizerRuleCollection.prototype.model = CategorizerRuleModel;

    return CategorizerRuleCollection;

  })(BaseCollection);
});
